'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('login', {
    url: '/login',
    template: require('./login/login.html'),
    controller: 'LoginController',
    controllerAs: 'vm'
  })
    .state('logout', {
      url: '/logout?referrer',
      referrer: 'main',
      template: '',
      controller($state, Auth) {
        'ngInject';

        var referrer = $state.params.referrer || $state.current.referrer || 'main';
        Auth.logout();
        $state.go(referrer);
      }
    })
    .state('signup', {
      url: '/signup',
      template: require('./signup/signup.html'),
      controller: 'SignupController',
      controllerAs: 'vm'
    })
    .state('forgot-password', {
      url: '/forgot-password',
      template: require('./forgot-password/forgot-password.html'),
      controller: 'ForgotPasswordController',
      controllerAs: 'vm'
    })
    .state('reset-password', {
      url: '/reset/:id/:token',
      template: require('./reset-password/reset-password.html'),
      controller: 'ResetPasswordController',
      controllerAs: 'vm'
    })
    .state('change-password', {
      url: '/change-password',
      template: require('./change-password/change-password.html'),
      controller: 'ChangePasswordController',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('activate-requested', {
      url: '/users/activate/:id',
      template: require('./activate-requested/activate-requested.html'),
      controller: 'ActivateRequestedController',
      controllerAs: 'vm'
    })
    .state('activate-suite-webaccess', {
      url: '/webaccess/activate/:webaccessId/:token',
      template: require('./activate-suite-webaccess/activate-suite-webaccess.html'),
      controller: 'ActivateSuiteWebaccessController',
      controllerAs: 'vm'
    })
    .state('reset-password-webaccess', {
      url: '/webaccess/reset/:id/:token',
      template: require('./reset-password-suite-webaccess/reset-password-suite-webaccess.html'),
      controller: 'ResetPasswordSuiteWebaccessController',
      controllerAs: 'vm'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js